import { useTranslation } from "react-i18next";
import { Sort } from "iconsax-react";
import { Select } from "@/shared/ui";
import { SORT_OPTIONS, type SortBy } from "../../../hooks";

interface Props {
  sortBy?: SortBy;
  onSortChange?: (value: SortBy) => void;
}

export default function AttachedDocumentsHeader({ sortBy, onSortChange }: Props) {
  const { t } = useTranslation("AttachedDocumentsPage");
  const sortOptions = SORT_OPTIONS.map((value) => ({
    value,
    label: t(`filters.sortOptions.${value}`),
  }));

  return (
    <div className="flex justify-between items-center pb-4 border-b surface-base-stroke mb-5 pt-1">
      <h1 className="text-display-xs content-base-primary">{t("title")}</h1>
      {sortBy && onSortChange && (
        <div className="min-w-52">
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={(v) => v && onSortChange(v as SortBy)}
            icon={<Sort size={16} color="currentColor" />}
          />
        </div>
      )}
    </div>
  );
}
